<template>
	<div class="w1">
	<div class="recommend_wrapper">
		<!-- recommend_wrapper -->
		<tuijian-dingyue />
		<div class="m_b1"></div>
		<div  class="group1 ">
			<tuijian-xinwen />
			<tuijian-reci />
		</div>
		<div class="m_b1"></div>
		<tuijian-rebang />
		<div class="m_b1"></div>

	</div><!-- /recommend_wrapper -->
	</div>
</template>

<script>
	import TuijianDingyue from '@/components/tuijian-dingyue.vue'
	import TuijianXinwen from '@/components/tuijian-xinwen.vue'
	import TuijianReci from '@/components/tuijian-reci.vue'
	import TuijianRebang from '@/components/tuijian-rebang.vue'

	export default {

		name: 'tuijian',
		components: {
			TuijianDingyue,
			TuijianXinwen,
			TuijianReci,
			TuijianRebang
		},
		mounted:function(){
			document.title='推荐-中经专网';
			this.$track([
				['pagetype','推荐']
			]);
		}
	}
</script>

<style>
</style>
